var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbstract2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_10215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1523 9.43359C22.1523 8.6905 22.7569 8.08594 23.5 8.08594C24.2431 8.08594 24.8477 8.6905 24.8477 9.43359V10.8711H32.9336V9.43359C32.9336 4.23191 28.7017 0 23.5 0C18.2983 0 14.0664 4.23191 14.0664 9.43359V21.6523H22.1523C22.1523 20.3686 22.1523 10.9743 22.1523 9.43359Z",
    fill: "#601B6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1523 32.4336V24.3477C20.8686 24.3477 11.4743 24.3477 9.93359 24.3477C9.1905 24.3477 8.58594 23.7431 8.58594 23C8.58594 22.2569 9.1905 21.6523 9.93359 21.6523H11.3711V13.5664H9.93359C4.73191 13.5664 0.5 17.7983 0.5 23C0.5 28.2017 4.73191 32.4336 9.93359 32.4336H22.1523Z",
    fill: "#601B6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8477 36.5664C24.8477 37.3095 24.2431 37.9141 23.5 37.9141C22.7569 37.9141 22.1523 37.3095 22.1523 36.5664V35.1289H14.0664V36.5664C14.0664 41.7681 18.2983 46 23.5 46C28.7017 46 32.9336 41.7681 32.9336 36.5664C32.9336 34.8623 32.9336 25.6871 32.9336 24.3477H24.8477V36.5664Z",
    fill: "#601B6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0664 13.5664C35.3623 13.5664 26.1871 13.5664 24.8477 13.5664V21.6523H37.0664C37.8095 21.6523 38.4141 22.2569 38.4141 23C38.4141 23.7431 37.8095 24.3477 37.0664 24.3477H35.6289V32.4336H37.0664C42.2681 32.4336 46.5 28.2017 46.5 23C46.5 17.7983 42.2681 13.5664 37.0664 13.5664Z",
    fill: "#601B6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_10215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstract2);
export default __webpack_public_path__ + "static/media/abstract-2.23064fd3e774343ee09cf8ca19f8fbca.svg";
export { ForwardRef as ReactComponent };